<!-- Start: Sidebar -->
<!-----------------------------------------------------------------+
       "#sidebar_left" Helper Classes:
    -------------------------------------------------------------------+
       * Positioning Classes:
        '.affix' - Sets Sidebar Left to the fixed position

       * Available Skin Classes:
         .sidebar-dark (default no class needed)
         .sidebar-light
         .sidebar-light.light
    -------------------------------------------------------------------+
       Example: <aside id="sidebar_left" class="affix sidebar-light">
       Results: Fixed Left Sidebar with light/white background
    ------------------------------------------------------------------->
<aside id="sidebar_left" class="nano nano-light affix sidebar-light">

    <!-- Start: Sidebar Left Content -->
    <div class="sidebar-left-content nano-content">

        <!-- Start: Sidebar Header -->
        <header class="sidebar-header">

            <!-- Sidebar Widget - Author -->
            <div class="sidebar-widget author-widget">
                <div class="media">
                    <a class="media-left" [routerLink]="['/profile',user.id]">
                        <img [src]="user.img" class="mw60 img-circle">
                    </a>
                    <div class="media-body">
                        <div class="media-links">
                          <!-- <a href="#" class="sidebar-menu-toggle">User Menu -</a> -->
                           <a (click)="authService.logout()" class="pointer">Logout</a>
                        </div>
                        <div class="media-author"> {{ user.firstname }} {{ user.lastname }} </div>
                    </div>
                </div>
            </div>

            <!-- Sidebar Widget - Menu (slidedown) -->
            <div class="sidebar-widget menu-widget">
                <div class="row text-center mbn">
                    <div class="col-xs-4">
                        <a routerLink="/dashboard" class="text-primary" data-toggle="tooltip" data-placement="top" title="Dashboard">
                            <span class="glyphicon glyphicon-home"></span>
                        </a>
                    </div>
                    <div class="col-xs-4">
                        <a href="pages_messages.html" class="text-info" data-toggle="tooltip" data-placement="top" title="Messages">
                            <span class="glyphicon glyphicon-inbox"></span>
                        </a>
                    </div>
                    <div class="col-xs-4">
                        <a href="pages_profile.html" class="text-alert" data-toggle="tooltip" data-placement="top" title="Tasks">
                            <span class="glyphicon glyphicon-bell"></span>
                        </a>
                    </div>
                    <div class="col-xs-4">
                        <a href="pages_timeline.html" class="text-system" data-toggle="tooltip" data-placement="top" title="Activity">
                            <span class="fa fa-desktop"></span>
                        </a>
                    </div>
                    <div class="col-xs-4">
                        <a href="pages_profile.html" class="text-danger" data-toggle="tooltip" data-placement="top" title="Settings">
                            <span class="fa fa-gears"></span>
                        </a>
                    </div>
                    <div class="col-xs-4">
                        <a class="text-warning" data-toggle="tooltip" data-placement="top" title="Cron Jobs">
                            <span class="fa fa-flask"></span>
                        </a>
                    </div>
                </div>
            </div>

            <!-- Sidebar Widget - Search (hidden) -->
            <div class="sidebar-widget search-widget hidden">
                <div class="input-group">
                    <span class="input-group-addon">
               <i class="fa fa-search"></i>
             </span>
                    <input type="text" id="sidebar-search" class="form-control" placeholder="Search...">
                </div>
            </div>

        </header>
        <!-- End: Sidebar Header -->

        <!-- Start: Sidebar Menu -->
        <ul class="nav sidebar-menu">

            <li class="sidebar-label pt15"></li>



            <li class="sidebar-label pt15">MENU</li>



            <li *ngFor="let menu of _sidebar.menu" routerLinkActive="active">
                <a class="accordion-toggle">
                    <!--routerLink="{{menu.url}}"-->
                    <span class="{{menu.icon}}"></span>
                    <span class="sidebar-title">{{ menu.title}}</span>
                    <span class="caret"></span>
                </a>

                <ul class="nav sub-nav">

                    <li *ngFor="let submenu of menu.submenu" routerLinkActive="active">
                        <a class="accordion-toggle" routerLink="{{submenu.url}}">
                            <span class="{{submenu.icon}}"></span>
                            <span class="sidebar-title">{{ submenu.title}}</span>
                            <span class="caret"></span>
                        </a>
                    </li>
                </ul>
            </li>




            <!-- sidebar progress bars -->
            <li class="sidebar-label pt25 pb10">Stats</li>
            <li class="sidebar-stat">
                <a href="#projectOne" class="fs11">
                    <span class="fa fa-bullhorn text-success"></span>
                    <span class="sidebar-title text-muted">Total Orders</span>
                    <span class="pull-right mr20 text-muted">{{ordersTotal}}</span>
                    <div class="progress progress-bar-xs mh20 mb10">
                        <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100" style="width: 100%">
                            <span class="sr-only">35% Complete</span>
                        </div>
                    </div>
                </a>
            </li>
            <li class="sidebar-stat">
                <a href="#projectOne" class="fs11">
                    <span class="fa fa-flag text-warning"></span>
                    <span class="sidebar-title text-muted">Orders Pending</span>
                    <span class="pull-right mr20 text-muted"> {{ordersPending}} </span>
                    <div class="progress progress-bar-xs mh20">
                        <div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width': pending+'%' }">
                            <span class="sr-only"> {{pending}}% </span>
                        </div>
                    </div>
                </a>
            </li>
            <li class="sidebar-stat">
              <a href="#projectOne" class="fs11">
                  <span class="fa fa-dropbox text-danger"></span>
                  <span class="sidebar-title text-muted">Orders Assigned</span>
                  <span class="pull-right mr20 text-muted"> {{ordersAsiggned}}  </span>
                  <div class="progress progress-bar-xs mh20">
                      <div class="progress-bar progress-bar-primary" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width': assigned+'%' }">
                          <span class="sr-only"> {{assigned}}% </span>
                      </div>
                  </div>
              </a>
          </li>
          <li class="sidebar-stat">
            <a href="#projectOne" class="fs11">
                <span class="fa fa-check-circle text-primary"></span>
                <span class="sidebar-title text-muted">Orders Delivered</span>
                <span class="pull-right mr20 text-muted"> {{ ordersDelivered }} </span>
                <div class="progress progress-bar-xs mh20">
                    <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width': delivered+'%' }">
                        <span class="sr-only"> {{delivered}}%</span>
                    </div>
                </div>
            </a>
        </li>
        <li class="sidebar-stat">
          <a href="#projectOne" class="fs11">
              <span class="fa fa-minus-circle text-primary"></span>
              <span class="sidebar-title text-muted">Orders Reject</span>
              <span class="pull-right mr20 text-muted"> {{ ordersReject }} </span>
              <div class="progress progress-bar-xs mh20">
                  <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width': reject+'%' }">
                      <span class="sr-only"> {{reject}}% </span>
                  </div>
              </div>
          </a>
      </li>
        </ul>
        <!-- End: Sidebar Menu -->

        <!-- Start: Sidebar Collapse Button -->
        <div class="sidebar-toggle-mini">
            <a href="#">
                <span class="fa fa-sign-out"></span>
            </a>
        </div>
        <!-- End: Sidebar Collapse Button -->

    </div>
    <!-- End: Sidebar Left Content -->

</aside>


<!-- End: Sidebar Left -->
